import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { Routes, Route, useParams, Navigate, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import HomePage from '../../pages/HomePage';
import RconHackingPage from '../../pages/RconHackingPage';
import AccountChecker from '../../pages/AccountChecker';
import DdosTestingPage from '../../pages/DdosTestingPage';
import ServerDatabasePage from '../../pages/ServerDatabasePage';
import ServerDataExtractionPage from '../../pages/ServerDataExtractionPage';
import BotConnectionPage from '../../pages/BotConnectionPage';
import ZeroDayMethodPage from '../../pages/ZeroDayMethodPage';
import AccountPage from '../../pages/AccountPage';
import TermsPage from '../../pages/TermsPage';
import MonitoringParserPage from '../../pages/MonitoringParserPage';
import AuthCallback from '../../pages/AuthCallback';

const ReferralHandler = () => {
  const { code } = useParams();
  useEffect(() => {
    if (code) {
      localStorage.setItem('referralCode', code);
    }
  }, [code]);

  const isEn = window.location.pathname.startsWith('/en');
  return <Navigate to={isEn ? '/en' : '/'} replace />;
};

const pageVariants = {
  initial: {
    opacity: 0,
    y: 0,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.23,
      ease: [0.16, 1, 0.3, 1],
    },
  },
  exit: (prevScroll) => ({
    opacity: 0,
    y: -(prevScroll || 0),
    transition: {
      opacity: {
        duration: 0.17,
        ease: [0.22, 1, 0.36, 1],
      },
      y: {
        duration: 0,
      },
    },
  }),
};

const LanguageRoutes = ({ openModal, closeModal }) => {
  const location = useLocation();
  const prevPathRef = useRef(location.pathname);
  const exitScrollRef = useRef(0);

  if (prevPathRef.current !== location.pathname) {
    exitScrollRef.current = typeof window !== 'undefined' ? window.scrollY : 0;
    prevPathRef.current = location.pathname;
  }

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="grid grid-cols-1 grid-rows-1 w-full flex-1 min-w-0">
      <AnimatePresence custom={exitScrollRef.current} initial={false}>
        <motion.div
          key={location.pathname}
          custom={exitScrollRef.current}
          variants={pageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          className="col-start-1 row-start-1 w-full min-w-0"
        >
          <Routes location={location}>
          {/* Русские маршруты */}
          <Route path="/" element={<HomePage openModal={openModal} />} />
          <Route path="/rcon-audit" element={<RconHackingPage openModal={openModal} />} />
          <Route path="/account-checker" element={<AccountChecker openModal={openModal} />} />
          <Route path="/ddos" element={<DdosTestingPage openModal={openModal} />} />
          <Route path="/servers" element={<ServerDatabasePage openModal={openModal} closeModal={closeModal} />} />
          <Route path="/server-data-extraction" element={<ServerDataExtractionPage openModal={openModal} />} />
          <Route path="/bots" element={<BotConnectionPage openModal={openModal} />} />
          <Route path="/secret" element={<ZeroDayMethodPage openModal={openModal} />} />
          <Route path="/account" element={<AccountPage openModal={openModal} />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/monitoring-parser" element={<MonitoringParserPage openModal={openModal} />} />
          <Route path="/servers-parser" element={<MonitoringParserPage openModal={openModal} />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/r=:code" element={<ReferralHandler />} />

          {/* Английские маршруты */}
          <Route path="/en" element={<HomePage openModal={openModal} />} />
          <Route path="/en/rcon-audit" element={<RconHackingPage openModal={openModal} />} />
          <Route path="/en/account-checker" element={<AccountChecker openModal={openModal} />} />
          <Route path="/en/ddos" element={<DdosTestingPage openModal={openModal} />} />
          <Route path="/en/servers" element={<ServerDatabasePage openModal={openModal} closeModal={closeModal} />} />
          <Route path="/en/server-data-extraction" element={<ServerDataExtractionPage openModal={openModal} />} />
          <Route path="/en/bots" element={<BotConnectionPage openModal={openModal} />} />
          <Route path="/en/secret" element={<ZeroDayMethodPage openModal={openModal} />} />
          <Route path="/en/account" element={<AccountPage openModal={openModal} />} />
          <Route path="/en/terms" element={<TermsPage />} />
          <Route path="/en/monitoring-parser" element={<MonitoringParserPage openModal={openModal} />} />
          <Route path="/en/servers-parser" element={<MonitoringParserPage openModal={openModal} />} />
          <Route path="/en/auth/callback" element={<AuthCallback />} />
          <Route path="/en/r=:code" element={<ReferralHandler />} />
          <Route path="/en/" element={<Navigate to="/en" replace />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  </div>
  );
};

export default LanguageRoutes;
